export const GET_MY_PIN_LIST_PATH = '/v2/user-pins';

export function get_my_pin_list_path() {
  return GET_MY_PIN_LIST_PATH;
}
